module.exports = __webpack_public_path__ + "static/media/liked.b268a305.svg";